import heroLevel1CharsDesk from 'assets/images/pumpkinRush/hero-level-1-chars-desk.webp';
import heroLevel1CharsMob from 'assets/images/pumpkinRush/hero-level-1-chars-mob.webp';
import heroLevel2CharsDesk from 'assets/images/pumpkinRush/hero-level-2-chars-desk.webp';
import heroLevel2CharsMob from 'assets/images/pumpkinRush/hero-level-2-chars-mob.webp';
import heroLevel3CharsDesk from 'assets/images/pumpkinRush/hero-level-3-chars-desk.webp';
import heroLevel3CharsMob from 'assets/images/pumpkinRush/hero-level-3-chars-mob.webp';
import heroLevel4CharsDesk from 'assets/images/pumpkinRush/hero-level-4-chars-desk.webp';
import heroLevel4CharsMob from 'assets/images/pumpkinRush/hero-level-4-chars-mob.webp';
import pumpkinL1Src from 'assets/images/pumpkinRush/pumpkin-l1.webp';
import pumpkinL2Src from 'assets/images/pumpkinRush/pumpkin-l2.webp';
import pumpkinL3Src from 'assets/images/pumpkinRush/pumpkin-l3.webp';
import pumpkinL4Src from 'assets/images/pumpkinRush/pumpkin-l4.webp';
import type { Breakpoint } from 'components/progressBars/BreakpointsProgressBar';
import { bonusRestrictedGroups, USER_GROUP } from 'helpers/user';
import type { ILevelConfig } from '../types';
import { ELevelKey, EProgressStep, ERewardMode } from '../types';

export const PUMPKIN_RUSH_NS = 'pumpkinRush';

export const PUMPKIN_RUSH_URL = '/pumpkin-rush';

// pumpkin_rush_l2_50
export const STATUS_GROUP_PATTERN = /^pumpkin_rush_(l\d)_(\d+)$/;

// set by the weekly snapshot for the highest level completed that week; the
// weekly reward bonus is keyed the same way
export const SCHEDULER_GROUP_PATTERN = /^pumpkin_rush_scheduler_l(\d)$/;

/**
 * The platform reuses bonuses of earlier promos for the instant rewards, so the
 * keys share no pattern and are matched one by one: key -> level order.
 */
export const INSTANT_REWARD_KEYS: Readonly<Record<string, number>> = {
  love_quest_entry: 1,
  love_quest_l1: 2,
  pumpkin_cash: 3,
  love_quest_l3: 4,
};

/**
 * A week runs Monday 12:00 UTC to Monday 12:00 UTC, the moment the weekly
 * reward of the closed one is issued. The first week opens with the promo, the
 * last one closes for bets with it but its reward still comes on Monday.
 */
export const CYCLE_ENDS: readonly string[] = [
  '2026-10-26T12:00:00Z',
  '2026-11-02T12:00:00Z',
  '2026-11-09T12:00:00Z',
];

export const BONUSES_URL = '/bonuses?tab=active-offers';
export const GAMES_URL = '/';

export const PROGRESS_STEPS: readonly EProgressStep[] = [
  EProgressStep.START,
  EProgressStep.QUARTER,
  EProgressStep.HALF,
  EProgressStep.THREE_QUARTERS,
  EProgressStep.COMPLETE,
];

// 25/50/75% thresholds are evenly spread, so they are derived — see getLevelThreshold
export const LEVELS: readonly ILevelConfig[] = [
  {
    key: ELevelKey.L1,
    order: 1,
    startAmount: 0,
    targetAmount: 1000,
    rewardMode: ERewardMode.AUTO,
    artifact: pumpkinL1Src,
    heroCharsDesk: heroLevel1CharsDesk,
    heroCharsMob: heroLevel1CharsMob,
  },
  {
    key: ELevelKey.L2,
    order: 2,
    startAmount: 1000,
    targetAmount: 4000,
    rewardMode: ERewardMode.AUTO,
    artifact: pumpkinL2Src,
    heroCharsDesk: heroLevel2CharsDesk,
    heroCharsMob: heroLevel2CharsMob,
  },
  {
    key: ELevelKey.L3,
    order: 3,
    startAmount: 4000,
    targetAmount: 10_000,
    rewardMode: ERewardMode.AUTO,
    artifact: pumpkinL3Src,
    heroCharsDesk: heroLevel3CharsDesk,
    heroCharsMob: heroLevel3CharsMob,
  },
  {
    key: ELevelKey.L4,
    order: 4,
    startAmount: 10_000,
    targetAmount: 25_000,
    rewardMode: ERewardMode.LOOTBOX,
    artifact: pumpkinL4Src,
    heroCharsDesk: heroLevel4CharsDesk,
    heroCharsMob: heroLevel4CharsMob,
  },
];

export const DEFAULT_STATUS_GROUP = {
  levelKey: ELevelKey.L1,
  step: EProgressStep.START,
} as const;

export const PROGRESS_BREAKPOINTS: Breakpoint[] = PROGRESS_STEPS.map(
  (percentage) => ({ percentage, title: `${percentage}` })
);

export const RESTRICTED_GROUPS = [
  ...bonusRestrictedGroups,
  USER_GROUP.RISK_SEGMENT_S1,
  USER_GROUP.RISK_SEGMENT_S2,
];
